import { UserCommitmentRanking } from 'models/ranking/commitmentRanking/UserCommitmentRanking';

export class UserCommitmentRankingService {
	toModel(ranking) {
		return new UserCommitmentRanking(ranking);
	}
}
